import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path fill="var(--color-difficulty-easy)" d="M20.25 12a8.25 8.25 0 1 1-16.5 0 8.25 8.25 0 0 1 16.5 0" />
  </>
);

const DifficultyEasy = Icon('difficulty-easy', svgContents);

export default DifficultyEasy;
